import React from "react";
import "./Footer.css";
import instaIcon from '../../assets/instaIcon.png'

const Footer = () => {
  return (
    <footer className="footer">
      <a href="https://www.instagram.com/priyapratapmakeup.studio/"
          target="_blank"
          rel="noopener noreferrer">
      <div className="insta-icon" >
        <img alt="Instagram Icon" src={instaIcon} />
      </div>
      </a>
      <div className="footer-content">
        
        <div className="footer-section">
          <h4>Phone & E-Mail</h4>
          <p>+91 8279373678</p>
          <p>priyapratapmakeup@gmail.com</p>
        </div>

        <div className="footer-section">
          <h4>Address</h4>
          <p>3rd Floor, Raj Complex, Judge-Shakti Road, above to Kalyan Jewellers</p>
          <p>Bijnor, Uttar Pradesh 246701</p>
          {/* 2nd Floor, Judge-Shakti Road, Raj Complex, opposite to Tanishq, Bijnor, Uttar Pradesh 246701 */}
        </div>

        <div className="footer-section">
          <h4>Opening Times</h4>
          {/* <p>+91 918279373678</p>
          <p>office@example.com</p> */}
          <p>Monday:    09:30 AM - 08:30 PM</p>
          <p>Tuesday:   09:30 AM - 08:30 PM</p>
          <p>Wednesday: 09:30 AM - 08:30 PM</p>
          <p>Thursday:  09:30 AM - 08:30 PM</p>
          <p>Friday:    09:30 AM - 08:30 PM</p>
          <p>Saturday:  09:30 AM - 08:30 PM</p>
          <p>Sunday:    09:30 AM - 08:30 PM</p>
        </div>

        <div className="footer-button">
          <button onClick={() => window.open('https://wa.me/918279373678', '_blank')}>Book Now</button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
